module.exports = __webpack_public_path__ + "media/images/brand/app_logo_250-282b6e83d9f95cd645a984a89a453a35.png";